import { Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

import { IQuestionOptionForm } from '../../../../models/type-forms/question-form-group.interface';

@Component({
  selector: 'empathy-variable-choices-form',
  templateUrl: 'variable-choices-form.component.html',
  styleUrls: ['./variable-choices-form.component.scss']
})
export class VariableChoicesFormComponent {
  @Input() options: FormArray<FormGroup<IQuestionOptionForm>>;
}
